import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faBold } from '@fortawesome/pro-light-svg-icons';

export type ProLightBoldProps = IconComponentProps;

export const ProLightBold = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightBoldProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faBold}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faBold}
    />
  );
};

ProLightBold.displayName = 'ProLightBold';
